<template>
    <div class="u-txt-center">
        <h2 class="h-lg u-mrg-btm-half" v-html="forgotPasswordTitle"></h2>
        <p v-html="subheader"></p>
        <div class="u-mrg-btm-half">
            <label for="forgotPassword" class="u-vis-hidden">
                Email address
            </label>
            <input v-if="!passwordSent" type="email" name="forgotPassword" id="forgotPassword" placeholder="Email Address*"
                v-model="emailAddress" class="input" />
            <div class="error u-padd-btm-none" v-show="submitted && emailAddress === ''">
                <strong>Please enter your email.</strong>
            </div>
            <div class="error u-padd-btm-none" v-show="submitted && invalidEmail">
                <strong>Please enter a valid email address.</strong>
            </div>
        </div>
        <button class="btn btn--blue btn--wide u-mrg-center u-mrg-top-half u-mrg-btm u-display-block"
            @click.prevent="ctaClick" v-html="cta">
        </button>
        <a v-if="isModal" @click="cancel" class="u-mrg-btm link-cta cursor-pointer">Cancel</a>
    </div>
</template>
<script>
import simpleUserApi from '../../utils/api/simpleUserApi.js';
import { isValidEmail } from '../../utils/forms/helpers.js';
export default {
    props: {
        //ForgotPasswordModal props
        forgotPasswordTitle: String,
        forgotPasswordSubhead: String,
        forgotPasswordCta: String,
        forgotPasswordSubheadSuccess: String,
        forgotPasswordCtaSuccess: String,
        accountLoginUrl: String,
        'isModal': {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            submitted: false,
            emailAddress: null,
            invalidEmail: false,
            passwordSent: false,
        }
    },
    mounted() {

    },
    beforeUnmount() {

    },
    computed: {
        subheader() {
            return this.passwordSent ? this.forgotPasswordSubheadSuccess : this.forgotPasswordSubhead;
        },
        cta() {
            return this.passwordSent ? this.forgotPasswordCtaSuccess : this.forgotPasswordCta;
        }
    },
    methods: {
        async ctaClick() {
            if (!this.passwordSent) {
                let valid = this.isValid();
                this.submitted = true;
                if (valid) {
                    const result = await simpleUserApi.resetPasswordRequest(this.emailAddress);
                    if (result.success) {
                        this.passwordSent = true;
                        this.$emit("userAction", "resetSent");
                    } else {
                        //todo: show some sort of message?
                    }

                }
            } else {
                //the button has changed meanings here to be login
                if(this.isModal){
                    this.$emit("userAction", "login");
                } else{
                    window.location = this.accountLoginUrl;
                }
            } 
        },
        isValid() {
            let valid = true;
            // if (!this.emailAddress === '' && !isValidEmail(this.emailAddress)) {
            if (this.emailAddress !== '' && !isValidEmail(this.emailAddress)) {
                this.invalidEmail = true;
                // console.log('email fields failed');
                valid = false;
            } else {
                //turns off red warning
                this.invalidEmail = false;
            }
            return valid;
        },
        cancel(){
            this.$emit("userAction", "cancel");
        }
    }
}
</script>